/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.invalidTier]:
    '您的版本不支援對 {application} 的整合。請聯絡您的帳戶管理員以升級您的 {brand} 版本。',
  [permissionsMessages.insufficientPrivilege]:
    '權限不足。請聯絡您的客戶代表進行升級。',
} as const;

// @key: @#@"[permissionsMessages.invalidTier]"@#@ @source: @#@"Your edition does not support {application} integration. Please contact your account representative to upgrade your {brand} edition."@#@
// @key: @#@"[permissionsMessages.insufficientPrivilege]"@#@ @source: @#@"Insufficient privilege. Please contact your account representative for an upgrade."@#@
